// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BorderOutlinedSvg from "@ant-design/icons-svg/es/asn/BorderOutlined";
import AntdIcon from '../components/AntdIcon';

var BorderOutlined = function BorderOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BorderOutlinedSvg
  }));
};

BorderOutlined.displayName = 'BorderOutlined';
export default React.forwardRef(BorderOutlined);